





























































































import Vue from 'vue';
import {API, getDesserts} from '@/api';
import { mapActions } from 'vuex';
import PropietarioAgregarDialog from '@/components/propietarios/AgregarPropiet.vue';
import PropietarioBorrarDialog from '@/components/propietarios/BorrarPropiet.vue';
import PropietarioEditarDialog from '@/components/propietarios/EditarPropiet.vue';
import ContactosDialog from '@/components/propietarios/Contactos.vue';
import AsociarUnidadPropietario from '@/components/propietarios/AsociarUnidadPropietario.vue';
import DisociarUnidadPropietario from '@/components/propietarios/DisociarUnidadPropietario.vue';

export default Vue.extend({
  components: { PropietarioAgregarDialog, PropietarioBorrarDialog, PropietarioEditarDialog,
  ContactosDialog, AsociarUnidadPropietario, DisociarUnidadPropietario },
  data: () => ({
    singleSelect: false,
    row: null,
    selected: [],
    propietario: null,
    headers: [
      { text: 'Propietario/Inquilino', value: 'nombre' },
      { text: 'RFC', value: 'rfc' },
      { text: 'CURP', value: 'curp' },
      { text: 'Contactos Asignados', value: 'contactLength'},
    ],
    total: 0,
    Propietarios: [],
    loading: true,
    options: {
      page: 1,
      itemsPerPage: 20,
      sortBy: ['nombre'],
      sortDesc: [false],
    },
    dialog: false,
    Condominio: {},
    isSelectedEmpty: true,
    clicked: [],
  }),
  methods: {
    ...mapActions(['getPropietCondoList']),
    rowSelected(event) {
      const doubleClick = this.checkDoubleClick(event);
      if (doubleClick) {
        this.selected = [event];
        this.$nextTick(() => this.$refs.editarComponent.$refs.activatorButton.$el.click());
        return;
      }
      if (this.selected[0] && this.selected[0].id === event.id) {
        this.selected = [];
      } else {
        this.selected = [event];
      }
    },
    checkDoubleClick(obj) {
      const doubleClickTimeout = 350;
      const clickInfo = {
        propId: obj.id,
        expired: false,
      };
      window.setTimeout((click) => {
        click.expired = true;
      }, doubleClickTimeout, clickInfo);
      this.clicked.push(clickInfo);
      if (this.clicked.length >= 2) {
        if (this.clicked.length > 2) {
          this.clicked.shift();
        }
        const prev = this.clicked[0];
        const last = this.clicked[1];
        if (prev.propId === last.propId && !prev.expired) {
          return true;
        }
      }
      return false;
    },
    async loadData() {
      try {
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        const options = this.options;
        this.loading = true;
        const result = await this.$store.dispatch('getPropietCondoList', {admin, condo, options});
        console.debug('getPropietCondoList response: %o', result.content);
        this.Propietarios = result.content;
        this.total = result.totalElements;
        this.loading = false;
      } catch (e) {
        this.$toast.error(e);
      }
      this.loading = false;
      this.selected = [];
    },
    async pageEventHandler(page) { // cargar mas registros
      this.loadData();
    },
    async reloadGrid(event) {
      this.loadData();
    },
  },
  watch: {
    selected() {
      // console.log('watch selected: %o', this.selected);
      if (Array.isArray(this.selected) && this.selected.length === 0) {
        this.isSelectedEmpty = true;
        this.propietario = null;
      } else {
        this.isSelectedEmpty = false;
        this.propietario = this.selected[0];
      }
    },
  },
});
